export default __webpack_public_path__ + "static/media/large_img.a8fa9ca8.png";